import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';

interface deletePlayerRequest {
  playerId: string;
  remark: string;
}

interface deletePlayerResponse {
  memberId: string;
}

/** 플레이어 삭제 */
export const deletePlayer = async ({
  playerId,
  remark,
}: deletePlayerRequest) => {
  const { data } = await api.post<ApiResponseType<deletePlayerResponse>>(
    `/api/web/admins/players/${playerId}/delete`,
    {
      remark,
    }
  );

  return data;
};
